"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLocationAssetUpdateInputSchema = exports.APosLocationAssetCreateInputSchema = exports.APosLocationAssetSchema = exports.APosDepreciationMethodSchema = exports.APosDisposalReasonSchema = exports.APosAssetStatusSchema = exports.APosAssetCategorySchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosAssetCategorySchema = zod_1.z.enum([
    'equipment', 'furniture', 'vehicle', 'electronics', 'signage', 'fixtures', 'other',
]);
exports.APosAssetStatusSchema = zod_1.z.enum(['active', 'disposed']);
exports.APosDisposalReasonSchema = zod_1.z.enum(['sold', 'scrapped', 'donated', 'lost', 'other']);
exports.APosDepreciationMethodSchema = zod_1.z.enum(['straight-line', 'declining-balance', 'none']);
exports.APosLocationAssetSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    assetId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(200),
    category: exports.APosAssetCategorySchema,
    description: zod_1.z.string().max(500).optional(),
    serialNumber: zod_1.z.string().max(100).optional(),
    make: zod_1.z.string().max(100).optional(),
    model: zod_1.z.string().max(100).optional(),
    purchaseDate: zod_1.z.number(),
    purchasePrice: zod_1.z.number().nonnegative(),
    currentValue: zod_1.z.number().nonnegative(),
    depreciationMethod: exports.APosDepreciationMethodSchema.optional(),
    usefulLifeYears: zod_1.z.number().positive().optional(),
    warrantyExpiry: zod_1.z.number().optional(),
    disposalDate: zod_1.z.number().optional(),
    disposalReason: exports.APosDisposalReasonSchema.optional(),
    imageUrl: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(1000).optional(),
    status: exports.APosAssetStatusSchema.default('active'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLocationAssetCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(200),
    category: exports.APosAssetCategorySchema,
    description: zod_1.z.string().max(500).optional(),
    serialNumber: zod_1.z.string().max(100).optional(),
    make: zod_1.z.string().max(100).optional(),
    model: zod_1.z.string().max(100).optional(),
    purchaseDate: zod_1.z.number(),
    purchasePrice: zod_1.z.number().nonnegative(),
    currentValue: zod_1.z.number().nonnegative(),
    depreciationMethod: exports.APosDepreciationMethodSchema.optional(),
    usefulLifeYears: zod_1.z.number().positive().optional(),
    warrantyExpiry: zod_1.z.number().optional(),
    imageUrl: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(1000).optional(),
});
exports.APosLocationAssetUpdateInputSchema = exports.APosLocationAssetCreateInputSchema.partial().extend({
    status: exports.APosAssetStatusSchema.optional(),
    disposalDate: zod_1.z.number().optional(),
    disposalReason: exports.APosDisposalReasonSchema.optional(),
});
//# sourceMappingURL=location-asset.schema.js.map